import { render, staticRenderFns } from "./WebsiteDatabasesPanel.vue?vue&type=template&id=55c1bfe7&"
import script from "./WebsiteDatabasesPanel.vue?vue&type=script&lang=ts&"
export * from "./WebsiteDatabasesPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports